import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { AuthenticationService } from '../../../../authentication/authentication.service';
import { tap } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'mce-profile',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatMenuModule, RouterLink],
  templateUrl: './navigation-profile.component.html',
  styleUrl: './navigation-profile.component.scss',
})
export class NavigationProfileComponent {

  private auth = inject(AuthenticationService);
  private router = inject(Router);

  viewState = computed(() => {
    const user = this.auth.currentUserState()?.user;

    return {
      displayName: user?.displayName || 'My Account',
      profileImageSrc: user?.photoUrl?.value ?? '',
    }
  });

  logout = () =>
    this.auth.signOut().pipe(
      tap(() => this.router.navigate(['/authentication/signin']) )
    ).subscribe();

}
